import React from 'react'
import { Button, Chip, Grid, Typography } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'

// components
import PageTitle from '../../PageTitle/PageTitle'
// data
import { FormLoader } from '../../../Loader/FormLoader'
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl'
import Configuration from '../../../../Services/Api/Configuration'
import SubscriptionServices from '../../../../Services/Consumers/SubscriptionServices'
import { filterData, parseLocaleNumber } from '../../../../utils/helpers'
import {
  exportFiltersPayload,
  UsersFiltersPayload
} from '../../../../Services/Payloads/AuthenticatedUserPayload'
import { useKeycloak } from '@react-keycloak/web'
import { useStyles } from './Styles'
import Moment from 'react-moment'
import DateFilter from '../../Workspace/PaymentClaimsContent/DateFilter'

let { User_Config } = Configuration
export default function SubscriptionsReportContent ({ handleNotificationCall, locale }) {
  let classes = useStyles()
  const intl = useIntl()
  const { keycloak } = useKeycloak()
  const [count, setCount] = React.useState(0)
  const [currentFilter, setCurrentFilter] = React.useState(null)
  const rowsPerPage = User_Config.userSubscriptionsReportLimit
  const [sortOrder, setSortOrder] = React.useState({})
  const [data, setData] = React.useState(['Loading Data...'])
  const [loadedData, setLoadedData] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  const columns = [
    {
      name: 'payable_id',
      label: intl.formatMessage({ id: 'List.Table.PayableID' }),
      options: {
        filterType: 'textField',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='List.Table.PayableID'/>:
                <span>{v}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'payable_name',
      label: intl.formatMessage({ id: 'List.Table.PayableName' }),
      options: {
        filterType: 'textField',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='List.Table.PayableName'/>:
                <span>{v}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'payable_type',
      label: intl.formatMessage({ id: 'List.Table.PayableType' }),
      options: {
        filterOptions: {
          names: ['App\\Models\\Service', 'App\\Models\\Plan'],
          renderValue: v => ('App\\Models\\Service' === v) ? intl.formatMessage({ id: 'List.Table.PayableType.Option.Service' }) : intl.formatMessage({ id: 'List.Table.PayableType.Option.Plan' })
        },
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='List.Table.PayableType'/>:
                <span>{('App\\Models\\Service' === v) ? intl.formatMessage({ id: 'List.Table.PayableType.Option.Service' }) : intl.formatMessage({ id: 'List.Table.PayableType.Option.Plan' })}</span>
              </div>
            )
          }
        },
        customBodyRenderLite: (dataIndex) => {
          return data[dataIndex] &&
            <span>{('App\\Models\\Service' === data[dataIndex].payable_type) ?
              intl.formatMessage({ id: 'List.Table.PayableType.Option.Service' })
              : intl.formatMessage({ id: 'List.Table.PayableType.Option.Plan' })}</span>
        }
      }
    },
    {
      name: 'promo_code',
      label: intl.formatMessage({ id: 'List.Table.promo_code' }),
      options: {
        filter: false,
      }
    },
    {
      name: 'original_amount',
      label: intl.formatMessage({ id: 'List.Table.original_amount' }),
      options: {
        filter: false,
        customHeadLabelRender: (columnMeta) => (
          <div className={classes.priceColumnTh}>
            <span>{columnMeta.label}</span>
            <span><FormattedMessage id='Common.beforeDiscount' /></span>
          </div>
        )
      }
    },
    {
      name: 'discount_amount',
      label: intl.formatMessage({ id: 'List.Table.discount_amount' }),
      options: {
        filter: false,
      }
    },
    {
      name: 'price',
      label: intl.formatMessage({ id: 'List.Table.Price' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return data[dataIndex] && (data[dataIndex].price ?
            <div className={classes.priceChipWrapper}>
              <Chip
                icon={<MonetizationOnIcon/>}
                label={
                  <div className={classes.priceChip}>
                    <strong><FormattedNumber value={parseLocaleNumber(data[dataIndex].price)}/> <FormattedMessage
                      id='egp'/></strong>
                  </div>
                }
              />
            </div> : '')
        },
        customHeadLabelRender: (columnMeta) => (
          <div className={classes.priceColumnTh}>
            <span>{columnMeta.label}</span>
            <span><FormattedMessage id='Common.afterDiscount' /></span>
          </div>
        ),
      }
    },
    {
      name: 'duration',
      label: intl.formatMessage({ id: 'List.Table.Duration' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return data[dataIndex] && <FormattedMessage id={data[dataIndex].duration ?
            `List.Table.Duration.${data[dataIndex].duration}` : 'List.Table.Duration.null'}/>
        }
      }
    },
    {
      name: 'expiration_start',
      label: intl.formatMessage({ id: 'List.Table.ExpirationStart' }),
      options: {
        filter: true,
        display: 'false',
        filterType: 'custom',
        customBodyRenderLite: (dataIndex) => {
          return <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY h:mm a">{data[dataIndex].expiration_start}</Moment>
        },
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.dateChip}>
                <FormattedMessage id='List.Table.ExpirationStart'/>:
                <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY">{v[0]}</Moment>
              </div>
            )
          }
        },
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <DateFilter
              filterList={filterList}
              onChange={onChange}
              index={index}
              type={'date'}
              column={column}
              id="expiration_start"
              label={intl.formatMessage({ id: 'List.Table.ExpirationStart' })}
            />
          )
        }
      }
    },
    {
      name: 'expiration_end',
      label: intl.formatMessage({ id: 'List.Table.ExpirationEnd' }),
      options: {
        filter: true,
        display: 'false',
        filterType: 'custom',
        customBodyRenderLite: (dataIndex) => {
          return <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY h:mm a">{data[dataIndex].expiration_end}</Moment>
        },
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.dateChip}>
                <FormattedMessage id='List.Table.ExpirationEnd'/>:
                <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY">{v[0]}</Moment>
              </div>
            )
          }
        },
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <DateFilter
              filterList={filterList}
              onChange={onChange}
              index={index}
              type={'date'}
              column={column}
              id="expiration_end"
              label={intl.formatMessage({ id: 'List.Table.ExpirationEnd' })}
            />
          )
        }
      }
    },
    {
      name: 'auto_renewal',
      label: intl.formatMessage({ id: 'List.Table.AutoRenewal' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return data[dataIndex] && <FormattedMessage id={data[dataIndex].auto_renewal ?
            `List.Table.AutoRenewal.${data[dataIndex].auto_renewal}` : 'List.Table.AutoRenewal.null'}/>
        }
      }
    },
    {
      name: 'paid_date',
      label: intl.formatMessage({ id: 'PaymentHeader.createDate' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return data[dataIndex] &&
            <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY h:mm a">{data[dataIndex].paid_date}</Moment>
        }
      }
    },
    {
      name: 'receipt_number',
      label: intl.formatMessage({ id: 'PaymentHeader.receiptNumber' }),
      options: {
        filter: false,
        display: 'false'
      }
    }
  ]

// get data
  const getUsersListData = async (page) => {
    await xhrRequest(page)
  }
  // mock async function
  const xhrRequest = (page, sortOrder = {}, clear, sortFieldName = '') => {
    if (!!keycloak?.authenticated) {

      setIsLoading(true)
      setSortOrder(sortOrder)

      if (!!loadedData[page] && !!loadedData[page].length && !clear) {
        setData(loadedData[page])
        setIsLoading(false)
      } else {
        SubscriptionServices.getSubscriptionsReport({
          headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
          params: filterData(UsersFiltersPayload(page, rowsPerPage, currentFilter))
        }).then((result) => {
          if ((!!result.response && result.response.status !== 200) || !result) {
            let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })
            if (result.response.data && result.response.data.status) {
              if (result.response.status === 403) {
                setData([])
                message = intl.formatMessage({ id: 'BasicInfo.AccessDeniedAlert' })
              } else if (result.response.data.status.errors && result.response.status === 422) {
                message = result.response.data.status.errors
              } else if (result.response.data.status.message) {
                message = result.response.data.status.message
              }
            }
            handleNotificationCall({
              type: 'defence',
              message: message,
              color: 'error'
            }, 'error')
            // setUserCompaniesFailure(true)
          } else {
            if (!!result && !!result.data && !!result.data.data) {
              let newData = []
              result.data.data.forEach((subscription) => {
                newData.push({
                  payable_id: subscription.payable.id,
                  payable_name: subscription.payable.title,
                  payable_type: subscription?.payment_receipt?.payment_request?.payable_type || '',
                  duration: subscription.duration,
                  auto_renewal: subscription.auto_renewal,
                  price: subscription.price,
                  expiration_start: subscription.start,
                  expiration_end: subscription.end,
                  paid_date: subscription?.payment_receipt?.create_at || '',
                  receipt_number: subscription?.payment_receipt?.receipt_number || '',
                  original_amount: subscription?.original_amount,
                  discount_amount: subscription?.discount_amount,
                  promo_code: subscription?.promo_code,
                })
              })


              let sortField = sortOrder.name
              let sortDir = sortOrder.direction

              if (sortField) {
                newData = newData.sort((a, b) => {
                  if (a[sortField] < b[sortField]) {
                    return 1 * (sortDir === 'asc' ? -1 : 1)
                  } else if (a[sortField] > b[sortField]) {
                    return -1 * (sortDir === 'asc' ? -1 : 1)
                  } else {
                    return 0
                  }
                })
              }
              setData(newData)
              let prevData = loadedData
              prevData[page] = newData
              setLoadedData(prevData)
              setCount(result.data.meta.total)
            }
          }
        }).then(() => {
          setIsLoading(false)
        })
      }
    }
  }
  const sort = (page, sortOrder) => {
    setSortOrder(sortOrder)
    let sortField = sortOrder.name
    let sortDir = sortOrder.direction
    let newData = data

    if (sortField) {
      newData = newData.sort((a, b) => {
        if (a[sortField] < b[sortField]) {
          return 1 * (sortDir === 'asc' ? -1 : 1)
        } else if (a[sortField] > b[sortField]) {
          return -1 * (sortDir === 'asc' ? -1 : 1)
        } else {
          return 0
        }
      })
    }
    setData(newData)
    // xhrRequest(page, sortOrder)
  }
  React.useEffect(() => {
      getUsersListData(1)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const changePage = (page, sortOrder) => {
    xhrRequest(++page, sortOrder)
  }
  const changeFilter = (applyFilters) => {
    setLoadedData([])
    let filterList = applyFilters()
    let filters = {}
    filterList.forEach((filterItem, index) => {
      if (!!filterItem.length) {
        if ('active' === columns[index].name) {
          filters[columns[index].name] = !!filterItem[0] ? 1 : 0
        } else if (filterItem[0].length >= 1) {
          filters[columns[index].name] = filterItem[0]
        }
      }
    })
    setCurrentFilter(filters)
  }

  React.useEffect(() => {
      if (!!currentFilter) {
        xhrRequest(1, {}, true)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentFilter])

  const options = {
    filter: true,
    filterType: 'dropdown',
    responsive: 'simple',
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    serverSide: true,
    count: count,
    search: false,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [],
    sortOrder: sortOrder,
    confirmFilters: true,
    onDownload: (buildHead, buildBody, columns, data) => {
      SubscriptionServices.exportSubscriptionsReport({
        headers: {
          'Authorization': `Bearer ${keycloak?.token ?? ''}`,
          'Accept': 'application/octet-stream'
        },
        params: filterData(exportFiltersPayload(currentFilter)),
        responseType: 'blob'
      }).then((result) => {
        if (result.data) {
          const type = result.headers['content-type']
          const blob = new Blob([result.data], { type: type, encoding: 'UTF-8' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          const contentDisposition = result.headers['content-disposition']
          let fileName = `${intl.formatMessage({ id: 'PageTitle.SubscriptionsReport' })}.xlsx`
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch.length === 2)
              fileName = fileNameMatch[1]
          }
          link.setAttribute('download', fileName) //or any other extension
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        }
      })
      return false
    },
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div className={classes.ApplyFilterWrapper}>
          <Button color='primary' variant="contained" onClick={() => changeFilter(applyNewFilters)}>
            <FormattedMessage id='Users.List.Table.ApplyFilters'/></Button>
        </div>
      )
    },
    onFilterChange: (column, filterList, type) => {
      if (type === 'chip') {
        setLoadedData([])
        let newFilters = () => (filterList)
        console.log('updating filters via chip')
        changeFilter(newFilters)
      }
    },
    textLabels: {
      body: {
        noMatch: intl.formatMessage({ id: 'Users.List.Table.NoMatching' }),
        toolTip: intl.formatMessage({ id: 'Users.List.Table.Sort' }),
        columnHeaderTooltip: column => intl.formatMessage(
          { id: 'Users.List.Table.SortFor' },
          { label: column.label })
      },
      pagination: {
        next: intl.formatMessage({ id: 'Users.List.Table.NextPage' }),
        previous: intl.formatMessage({ id: 'Users.List.Table.PreviousPage' }),
        rowsPerPage: intl.formatMessage({ id: 'Users.List.Table.RowsPerPage' }),
        displayRows: intl.formatMessage({ id: 'Users.List.Table.Of' })
      },
      toolbar: {
        search: intl.formatMessage({ id: 'Users.List.Table.Search' }),
        downloadCsv: intl.formatMessage({ id: 'PaymentRequests.List.Table.Download' }),
        print: intl.formatMessage({ id: 'Users.List.Table.Print' }),
        viewColumns: intl.formatMessage({ id: 'Users.List.Table.ViewColumns' }),
        filterTable: intl.formatMessage({ id: 'Users.List.Table.FilterTable' })
      },
      filter: {
        all: intl.formatMessage({ id: 'Users.List.Table.All' }),
        title: intl.formatMessage({ id: 'Users.List.Table.FILTERS' }),
        reset: intl.formatMessage({ id: 'Users.List.Table.RESET' })
      },
      viewColumns: {
        title: intl.formatMessage({ id: 'Users.List.Table.ShowColumns' }),
        titleAria: intl.formatMessage({ id: 'Users.List.Table.ShowHideColumns' })
      }
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          changePage(tableState.page, tableState.sortOrder)
          break
        case 'sort':
          sort(tableState.page, tableState.sortOrder)
          break
        default:
          break
      }
    }
  }
  return (
    <>
      <PageTitle title={<FormattedMessage id='PageTitle.SubscriptionsReport'/>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.TableWrapper}>
          {isLoading && <FormLoader loading={true}/>}
          <MUIDataTable
            title={
              <Typography variant="h6">
                <FormattedMessage id='PageTitle.SubscriptionsReport'/>
              </Typography>
            }
            data={data}
            columns={columns}
            options={options}
          />
        </Grid>
      </Grid>
    </>
  )
}
